module.exports = __webpack_public_path__ + "static/media/Covert_Commands_Edge.0c2aaef6.mp3";